import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  events: [],
  lastEventId: null,
  lastDate: null,
};

const historicalEventSlice = createSlice({
  name: 'historicalEvent',
  initialState,
  reducers: {
    aGetHistoricalEventsSuccess: (state, action) => {
      state.events = action.payload.events;
      state.lastEventId = action.payload.lastEventId;
      state.lastDate = action.payload.lastDate;
    },
    aClearHistoricalEventsState: (state) => {
      state.events = [];
      state.lastEventId = null;
      state.lastDate = null;
    },
  },
});

export const {
  aGetHistoricalEventsSuccess,
  aClearHistoricalEventsState,
} = historicalEventSlice.actions;

export default historicalEventSlice.reducer;